import focusTrap from 'focus-trap-react';

export const FocusTrap = focusTrap;
